import { Checkbox, DateInput, Input, MaskedInput, Select } from '@cian/ui-kit';

import { FC } from 'react';

import { CustomFormField } from 'shared/components/CustomFormField';
import { FormFooterWithPrivacyPolicy } from 'shared/components/FormFooterWithPrivacyPolicy';
import { PHONE_MASK } from 'shared/constants/form/mask';

import { EBookCoworkingFormFields } from '../constants';

import { coworkingOfferTypeSelectOptions } from './internal/mappers/coworkingOfferTypeSelectOptions';
import { rentDurationUnitSelectOptions } from './internal/mappers/rentDurationUnitSelectOptions';
import { IBookCoworkingFromViewProps } from './types';

import * as styles from './BookCoworkingFromView.css';

export const BookCoworkingFromView: FC<IBookCoworkingFromViewProps> = props => {
  const {
    boundActions,
    checkFormFieldInvalid,
    disableFieldsOnPending = false,
    getFormFieldErrorMessage,
    getFormFieldValue,
    onBlur,
    onSubmit,
    pending = false,
  } = props;

  return (
    <form className={styles['form-container']} data-testid="book-coworking-from" onSubmit={onSubmit}>
      <div className={styles['form-group']}>
        <CustomFormField
          containerClassName={styles['form-element']}
          errorMessage={getFormFieldErrorMessage(EBookCoworkingFormFields.Name)}
          label="Ваше имя"
          testId="field_name"
        >
          <Input
            disabled={disableFieldsOnPending && pending}
            invalid={checkFormFieldInvalid(EBookCoworkingFormFields.Name)}
            placeholder="Введите ваше имя"
            value={getFormFieldValue(EBookCoworkingFormFields.Name)}
            onBlur={onBlur(EBookCoworkingFormFields.Name)}
            onChange={boundActions.setNameFieldValueAction}
          />
        </CustomFormField>

        <CustomFormField
          childrenContainerClassName={styles['phone-field']}
          containerClassName={styles['form-element']}
          errorMessage={getFormFieldErrorMessage(EBookCoworkingFormFields.Phone)}
          label="Номер телефона"
          testId="field_phone"
        >
          <MaskedInput
            data-testid="field_phone_masked"
            disabled={disableFieldsOnPending && pending}
            invalid={checkFormFieldInvalid(EBookCoworkingFormFields.Phone)}
            mask={PHONE_MASK}
            placeholder="+7"
            value={getFormFieldValue(EBookCoworkingFormFields.Phone)}
            onBlur={onBlur(EBookCoworkingFormFields.Phone)}
            onChange={boundActions.setPhoneFieldValueAction}
          />
        </CustomFormField>
      </div>

      <div className={styles['checkbox-container']} data-testid="field_is-broker">
        <Checkbox
          checked={getFormFieldValue(EBookCoworkingFormFields.IsBroker)}
          disabled={disableFieldsOnPending && pending}
          label="Я брокер, подбираю коворкинг для клиента"
          onBlur={onBlur(EBookCoworkingFormFields.IsBroker)}
          onChange={boundActions.setIsBrokerFieldValueAction}
        />
      </div>

      <div className={styles['form-group']}>
        <CustomFormField
          containerClassName={styles['form-element']}
          errorMessage={getFormFieldErrorMessage(EBookCoworkingFormFields.CoworkingOfferType)}
          label="Вы бронируете"
          testId="field_coworking-offer-type"
        >
          <Select
            disabled={disableFieldsOnPending && pending}
            invalid={checkFormFieldInvalid(EBookCoworkingFormFields.CoworkingOfferType)}
            options={coworkingOfferTypeSelectOptions}
            placeholder="Выберите вид"
            value={getFormFieldValue(EBookCoworkingFormFields.CoworkingOfferType)}
            onBlur={onBlur(EBookCoworkingFormFields.CoworkingOfferType)}
            onChange={boundActions.setCoworkingOfferTypeValueAction}
          />
        </CustomFormField>

        <CustomFormField
          containerClassName={styles['form-element']}
          errorMessage={getFormFieldErrorMessage(EBookCoworkingFormFields.WorkplaceCount)}
          label="Количество рабочих мест"
          testId="field_workplace-count"
        >
          <Input
            disabled={disableFieldsOnPending && pending}
            invalid={checkFormFieldInvalid(EBookCoworkingFormFields.WorkplaceCount)}
            placeholder="Укажите количество"
            type="number"
            value={getFormFieldValue(EBookCoworkingFormFields.WorkplaceCount)}
            onBlur={onBlur(EBookCoworkingFormFields.WorkplaceCount)}
            onChange={boundActions.setWorkplaceCountFieldValueAction}
          />
        </CustomFormField>

        <CustomFormField
          childrenContainerClassName={styles['input-select-field']}
          containerClassName={styles['form-element']}
          errorMessage={getFormFieldErrorMessage(EBookCoworkingFormFields.RentDuration)}
          label="Срок аренды"
          testId="field_rent-duration"
        >
          <Input
            disabled={disableFieldsOnPending && pending}
            invalid={checkFormFieldInvalid(EBookCoworkingFormFields.RentDuration)}
            placeholder="Введите срок аренды"
            type="number"
            value={getFormFieldValue(EBookCoworkingFormFields.RentDuration)}
            onBlur={onBlur(EBookCoworkingFormFields.RentDuration)}
            onChange={boundActions.setRentDurationFieldValueAction}
          />
          <Select
            disabled={disableFieldsOnPending && pending}
            invalid={checkFormFieldInvalid(EBookCoworkingFormFields.RentDurationUnit)}
            options={rentDurationUnitSelectOptions}
            value={getFormFieldValue(EBookCoworkingFormFields.RentDurationUnit)}
            onBlur={onBlur(EBookCoworkingFormFields.RentDurationUnit)}
            onChange={boundActions.setRentDurationUnitFieldValueAction}
          />
        </CustomFormField>

        <CustomFormField
          childrenContainerClassName={styles['rent-start-date-field']}
          containerClassName={styles['form-element']}
          errorMessage={getFormFieldErrorMessage(EBookCoworkingFormFields.RentStartDate)}
          label="Дата начала аренды"
          testId="field_rent-start-date"
        >
          <DateInput
            disabled={disableFieldsOnPending && pending}
            invalid={checkFormFieldInvalid(EBookCoworkingFormFields.RentStartDate)}
            min="today"
            value={getFormFieldValue(EBookCoworkingFormFields.RentStartDate)}
            onBlur={onBlur(EBookCoworkingFormFields.RentStartDate)}
            onChange={boundActions.setRentStartDateFieldValueAction}
          />
        </CustomFormField>
      </div>

      <FormFooterWithPrivacyPolicy submitButtonTitle="Забронировать" />
    </form>
  );
};

BookCoworkingFromView.displayName = 'BookCoworkingFromView';
